var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLvl3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 211.74 277.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2,.cls-3{fill:#fff;}.cls-3{font-family:Mont-HeavyDEMO, Mont;font-size:71.68px;letter-spacing:.04em;}.cls-4{fill:url(#linear-gradient-6);}.cls-5{fill:url(#linear-gradient-11);}.cls-6{fill:url(#linear-gradient-10);}.cls-7{fill:#343652;}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-3);}.cls-12{fill:url(#linear-gradient);}.cls-13{fill:url(#linear-gradient-4);}.cls-14{fill:url(#linear-gradient-8);}.cls-15{fill:url(#linear-gradient-12);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 99.72,
    y1: 74.76,
    x2: 99.72,
    y2: 230.63,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 141.39,
    y1: 74.76,
    x2: 141.39,
    y2: 230.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 141.39,
    y1: 74.76,
    x2: 141.39,
    y2: 230.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 141.39,
    y1: 74.76,
    x2: 141.39,
    y2: 230.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 141.39,
    y1: 74.76,
    x2: 141.39,
    y2: 230.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 141.39,
    y1: 74.76,
    x2: 141.39,
    y2: 230.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 141.39,
    y1: 74.76,
    x2: 141.39,
    y2: 230.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 141.39,
    y1: 74.76,
    x2: 141.39,
    y2: 230.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 141.39,
    y1: 74.76,
    x2: 141.39,
    y2: 230.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 137.98,
    y1: 277.17,
    x2: 89.64,
    y2: 117.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f05a26",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f05a26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 187.45,
    y1: 90.33,
    x2: 106.72,
    y2: 167.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9cf2f",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9cf2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 39.03,
    y1: 72.25,
    x2: 89.31,
    y2: 152.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41bb95",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41bb95"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 105.87,
    cy: 171.19,
    r: 105.87
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(80.82 190.42) scale(1.09 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 106.82,
    cy: 171.19,
    r: 90.97
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M111.46,162c12.22,2.82,20.03,11.9,20.03,24.03,0,15.93-13.43,27.33-32.13,27.33s-30.9-10.98-31.41-27.19h21.87c.26,5.52,3.99,9.19,9.6,9.19s9.91-3.94,9.91-9.66-4.23-9.27-10.86-9.27h-13.65v-4.36l13.88-20.96h-28.6v-17.85h58.47v3.6l-17.1,25.16h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.48,201.22l-4.71,.7,4.73,2.36v.73l-4.72,2.36,4.71,.69v2.49l-8.18-1.35v-2.45l4.45-2.1-4.45-2.11v-2.45l8.18-1.34v2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M141.39,197.58c-2.5,0-4.3-2.04-4.3-4.91s1.79-4.9,4.3-4.9,4.3,2.04,4.3,4.9-1.8,4.91-4.3,4.91Zm0-7.25c-1.28,0-2.2,.98-2.2,2.34s.93,2.35,2.2,2.35,2.2-1,2.2-2.35-.92-2.34-2.2-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M141.38,177.81c2.39,0,4.1,1.91,4.1,4.6v3.61h-8.18v-3.61c0-2.7,1.69-4.6,4.08-4.6Zm0,2.52c-1.21,0-2.02,.88-2.02,2.2v1.02h4.05v-1.02c0-1.32-.83-2.2-2.03-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M143.52,170.22h1.96v5.81h-8.18v-5.7h1.95v3.26h1.2v-2.93h1.85v2.93h1.22v-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.97,164.96v.89h2.5v2.46h-8.18v-3.86c0-1.92,1.18-3.31,2.89-3.31,1,0,1.83,.53,2.31,1.41l2.97-1.77v2.74l-2.5,1.44Zm-1.9,.89v-1.12c0-.69-.38-1.08-.89-1.08s-.89,.4-.89,1.08v1.12h1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M144.15,153.81v3.16l1.33,.49v2.63l-8.18-3.5v-2.4l8.18-3.58v2.7l-1.33,.49Zm-4.3,1.58l2.54,.98v-1.96l-2.54,.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M139.32,143.47v2.42h6.15v2.47h-6.15v2.42h-2.03v-7.31h2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M143.52,136.06h1.96v5.81h-8.18v-5.7h1.95v3.26h1.2v-2.93h1.85v2.93h1.22v-3.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M206.56,138.48l-41.5,13.49c1.97,6.06,3.04,12.52,3.04,19.23s-1.08,13.17-3.04,19.23c-2.04,6.28-5.05,12.12-8.85,17.34-3.84,5.28-8.49,9.92-13.77,13.77-5.23,3.8-11.06,6.81-17.34,8.85-6.06,1.97-12.52,3.04-19.23,3.04s-13.17-1.08-19.23-3.04c-6.28-2.04-12.12-5.05-17.34-8.85-5.28-3.84-9.92-8.49-13.77-13.77-3.8-5.23-6.81-11.06-8.85-17.34-1.97-6.06-3.04-12.52-3.04-19.23H0C0,182.62,1.83,193.6,5.18,203.91c3.47,10.68,8.59,20.61,15.06,29.5,6.53,8.98,14.44,16.88,23.42,23.42,8.89,6.47,18.82,11.59,29.5,15.06,10.31,3.35,21.3,5.18,32.72,5.18s22.41-1.83,32.72-5.18c10.68-3.47,20.61-8.59,29.5-15.06,8.98-6.53,16.88-14.44,23.42-23.42,6.47-8.89,11.59-18.82,15.06-29.5,3.35-10.31,5.18-21.3,5.18-32.72s-1.83-22.41-5.18-32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M191.51,108.97c-6.53-8.98-14.44-16.88-23.42-23.42-8.89-6.47-18.82-11.59-29.5-15.06l-13.49,41.5c6.28,2.04,12.12,5.05,17.34,8.85,5.28,3.84,9.92,8.49,13.77,13.77,3.8,5.23,6.81,11.06,8.85,17.34l41.5-13.49c-3.47-10.68-8.59-20.61-15.06-29.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M105.87,65.32c-11.42,0-22.41,1.83-32.72,5.18-10.68,3.47-20.61,8.59-29.5,15.06-8.98,6.53-16.88,14.44-23.42,23.42-6.47,8.89-11.59,18.82-15.06,29.5C1.83,148.78,0,159.77,0,171.19H43.64c0-6.71,1.08-13.17,3.04-19.23,2.04-6.28,5.05-12.12,8.85-17.34,3.84-5.28,8.49-9.92,13.77-13.77,5.23-3.8,11.06-6.81,17.34-8.85,6.06-1.97,12.52-3.04,19.23-3.04s13.17,1.08,19.23,3.04l13.49-41.5c-10.31-3.35-21.3-5.18-32.72-5.18Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.59,36.93h14.51v8.55H21.51V0h11.08V36.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.2,8.88v9.2h14.84v8.55h-14.84v9.98h16.78v8.88h-27.86V0h27.86V8.88h-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.58,0l-16.13,45.49h-13.87L81.44,0h11.79l11.27,34.34L115.85,0h11.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.96,8.88v9.2h14.84v8.55h-14.84v9.98h16.78v8.88h-27.86V0h27.86V8.88h-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.72,36.93h14.51v8.55h-25.59V0h11.08V36.93Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLvl3);
export default __webpack_public_path__ + "static/media/lvl3.6769b6c2ea58070ed00d0cbac2fdccd4.svg";
export { ForwardRef as ReactComponent };